angular.module('impactx.deliverynote').controller('DeliveryNoteInvalidationDetailCtrl', [
    '$scope',
    'TranslationService',
    'dataGen',
    '$mdDialog',
    '$redirect',
    'ToastService',
    'dnhId',
    DeliveryNoteInvalidationDetailCtrl]);

function DeliveryNoteInvalidationDetailCtrl($scope, TranslationService, dataGen, $mdDialog, $redirect, ToastService, dnhId) {

    dataGen.getData($scope, {id: dnhId}, "/deliverynote/viewInvalidation");
    
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.save = function () {
        dataGen.postAsForm($scope, {data: $scope.data}, "/deliverynote/doInvalidation").then(function () {
            $redirect.redirectTo(null, "/deliverynotelist");
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };
}

